// generated by tools/pictograms/buildPictogramArt.mjs, do not edit
import type { IconNode } from 'lucide-react'

import type { PictogramSlug } from './pictogramCatalog'

export type PictogramShardId =
  | 'brands'
  | 'conveyances'
  | 'craft-welfare'
  | 'deliveries-construction'
  | 'emergency'
  | 'entrances'
  | 'information'
  | 'materials-storage'
  | 'parking'
  | 'ppe-offices'

// The rounded tile every sign is cut from.
export const PICTOGRAM_TILE_PATH =
  'M0 8C0 3.6 3.6 0 8 0H32C36.4 0 40 3.6 40 8V32C40 36.4 36.4 40 32 40H8C3.6 40 0 36.4 0 32V8Z'

// What a sign is drawn with while its art loads: its tile in its main colour. Logos, on their own
// brand backgrounds, load in the neutral tone.
export const NEUTRAL_TONE = '#EEF2F6'
export const PICTOGRAM_TONES: Partial<Record<PictogramSlug, string>> = {
  'access-a': '#008035',
  'access-b': '#008035',
  'access-c': '#008035',
  'access-d': '#008035',
  'access-e': '#008035',
  'access-f': '#008035',
  'admin-office': '#005A9E',
  aed: '#DF1B22',
  'alarm-pull-station': '#D93030',
  'arc-flash': '#FFFFFF',
  area: '#005A9E',
  'bike-parking': '#005A9E',
  'break-area': '#005A9E',
  break: '#005A9E',
  'buggy-parking': '#005A9E',
  building: '#005A9E',
  canteen: '#005A9E',
  cleanroom: '#67497E',
  'concrete-washout': '#3A8A80',
  'confined-space': '#FFFFFF',
  'construction-debris-1': '#B06E2D',
  'construction-debris-2': '#B06E2D',
  'construction-vehicles': '#005A9E',
  'covid-checkpoint': '#DF1B22',
  'crane-zone': '#005A9E',
  deliveries: '#005A9E',
  door: '#005A9E',
  dumpster: '#005A9E',
  'electrical-room': '#005A9E',
  elevator: '#005A9E',
  entrance: '#008035',
  'equipment-storage': '#B06E2D',
  'erosion-control': '#3A8A80',
  'esd-zone': '#67497E',
  excavation: '#FFFFFF',
  'exit-running': '#008035',
  exit: '#008035',
  eyewash: '#2F7D3B',
  'fall-hazard': '#FFFFFF',
  'fire-extinguisher': '#DF1B22',
  'fire-hydrant': '#D93030',
  'fire-lane': '#D93030',
  'first-aid': '#DF1B22',
  flagger: '#FFFFFF',
  gate: '#005A9E',
  'hi-vis-apparel': '#005A9E',
  'hot-work': '#FFFFFF',
  'hydration-station': '#005A9E',
  'icra-zone': '#67497E',
  'information-area': '#67497E',
  level: '#005A9E',
  'loading-zone': '#235A9C',
  'mast-climber': '#005A9E',
  'material-boxes': '#B06E2D',
  'material-plumbing': '#B06E2D',
  'material-steel-1': '#B06E2D',
  'material-steel-2': '#B06E2D',
  'material-wood': '#B06E2D',
  'muster-point': '#DF1B22',
  'negative-pressure': '#67497E',
  'no-access-1': '#FFFFFF',
  'no-access-2': '#FFFFFF',
  'no-access-3': '#FFFFFF',
  'no-drones': '#FFFFFF',
  'no-photography': '#FFFFFF',
  noise: '#FFFFFF',
  'not-required-all': '#005A9E',
  'not-required-apparel': '#005A9E',
  'not-required-boots': '#005A9E',
  'not-required-gloves': '#005A9E',
  'not-required-helmet': '#005A9E',
  'one-way': '#005A9E',
  'overhead-load': '#FFFFFF',
  parking: '#005A9E',
  'pedestrian-walkway': '#005A9E',
  'restrooms-men': '#005A9E',
  'restrooms-women': '#005A9E',
  restrooms: '#005A9E',
  route: '#005A9E',
  'safety-boots': '#005A9E',
  'safety-gloves': '#005A9E',
  'safety-helmet': '#005A9E',
  scaffold: '#005A9E',
  'security-checkpoint': '#005A9E',
  shaft: '#005A9E',
  'silica-dust': '#FFFFFF',
  'site-map': '#67497E',
  'smoking-area': '#005A9E',
  'speed-limit': '#FFFFFF',
  'spill-kit': '#3A8A80',
  stairs: '#005A9E',
  standpipe: '#D93030',
  stop: '#FFFFFF',
  'storm-drain': '#3A8A80',
  'swing-stage': '#005A9E',
  'temporary-water': '#005A9E',
  trailer: '#005A9E',
  'truck-crossing': '#FFFFFF',
  'visitor-check-in': '#005A9E',
  'wash-area': '#005A9E',
  'wheel-wash': '#235A9C',
  yield: '#FFFFFF',
  zone: '#005A9E',
}

export const PICTOGRAM_SHARDS: Record<PictogramSlug, PictogramShardId> = {
  'brand-equipmentshare': 'brands',
  'brand-feco': 'brands',
  'brand-herc-rentals': 'brands',
  'brand-oes': 'brands',
  'brand-sunbelt': 'brands',
  'brand-united-rentals': 'brands',
  elevator: 'conveyances',
  'mast-climber': 'conveyances',
  'pedestrian-walkway': 'conveyances',
  scaffold: 'conveyances',
  shaft: 'conveyances',
  stairs: 'conveyances',
  'swing-stage': 'conveyances',
  'break-area': 'craft-welfare',
  break: 'craft-welfare',
  canteen: 'craft-welfare',
  dumpster: 'craft-welfare',
  'hydration-station': 'craft-welfare',
  'restrooms-men': 'craft-welfare',
  'restrooms-women': 'craft-welfare',
  restrooms: 'craft-welfare',
  'smoking-area': 'craft-welfare',
  'wash-area': 'craft-welfare',
  'construction-vehicles': 'deliveries-construction',
  'crane-zone': 'deliveries-construction',
  deliveries: 'deliveries-construction',
  'fire-lane': 'deliveries-construction',
  flagger: 'deliveries-construction',
  'loading-zone': 'deliveries-construction',
  'one-way': 'deliveries-construction',
  'security-checkpoint': 'deliveries-construction',
  'speed-limit': 'deliveries-construction',
  stop: 'deliveries-construction',
  'temporary-water': 'deliveries-construction',
  trailer: 'deliveries-construction',
  'truck-crossing': 'deliveries-construction',
  yield: 'deliveries-construction',
  aed: 'emergency',
  'alarm-pull-station': 'emergency',
  'arc-flash': 'emergency',
  'confined-space': 'emergency',
  'covid-checkpoint': 'emergency',
  excavation: 'emergency',
  eyewash: 'emergency',
  'fall-hazard': 'emergency',
  'fire-extinguisher': 'emergency',
  'fire-hydrant': 'emergency',
  'first-aid': 'emergency',
  'hot-work': 'emergency',
  'muster-point': 'emergency',
  noise: 'emergency',
  'overhead-load': 'emergency',
  'silica-dust': 'emergency',
  standpipe: 'emergency',
  'access-a': 'entrances',
  'access-b': 'entrances',
  'access-c': 'entrances',
  'access-d': 'entrances',
  'access-e': 'entrances',
  'access-f': 'entrances',
  door: 'entrances',
  entrance: 'entrances',
  'exit-running': 'entrances',
  exit: 'entrances',
  gate: 'entrances',
  'no-access-1': 'entrances',
  'no-access-2': 'entrances',
  'no-access-3': 'entrances',
  'no-drones': 'entrances',
  'no-photography': 'entrances',
  route: 'entrances',
  area: 'information',
  building: 'information',
  'information-area': 'information',
  level: 'information',
  'site-map': 'information',
  zone: 'information',
  'concrete-washout': 'materials-storage',
  'construction-debris-1': 'materials-storage',
  'construction-debris-2': 'materials-storage',
  'equipment-storage': 'materials-storage',
  'erosion-control': 'materials-storage',
  'material-boxes': 'materials-storage',
  'material-plumbing': 'materials-storage',
  'material-steel-1': 'materials-storage',
  'material-steel-2': 'materials-storage',
  'material-wood': 'materials-storage',
  'spill-kit': 'materials-storage',
  'storm-drain': 'materials-storage',
  'wheel-wash': 'materials-storage',
  'bike-parking': 'parking',
  'buggy-parking': 'parking',
  parking: 'parking',
  'admin-office': 'ppe-offices',
  cleanroom: 'ppe-offices',
  'electrical-room': 'ppe-offices',
  'esd-zone': 'ppe-offices',
  'hi-vis-apparel': 'ppe-offices',
  'icra-zone': 'ppe-offices',
  'negative-pressure': 'ppe-offices',
  'not-required-all': 'ppe-offices',
  'not-required-apparel': 'ppe-offices',
  'not-required-boots': 'ppe-offices',
  'not-required-gloves': 'ppe-offices',
  'not-required-helmet': 'ppe-offices',
  'safety-boots': 'ppe-offices',
  'safety-gloves': 'ppe-offices',
  'safety-helmet': 'ppe-offices',
  'visitor-check-in': 'ppe-offices',
}

// The one place that knows where the art lives: swap these to serve it from elsewhere.
export const PICTOGRAM_SHARD_LOADERS: Record<
  PictogramShardId,
  () => Promise<{ default: Partial<Record<PictogramSlug, IconNode>> }>
> = {
  brands: () => import('./art/brands.generated'),
  conveyances: () => import('./art/conveyances.generated'),
  'craft-welfare': () => import('./art/craft-welfare.generated'),
  'deliveries-construction': () =>
    import('./art/deliveries-construction.generated'),
  emergency: () => import('./art/emergency.generated'),
  entrances: () => import('./art/entrances.generated'),
  information: () => import('./art/information.generated'),
  'materials-storage': () => import('./art/materials-storage.generated'),
  parking: () => import('./art/parking.generated'),
  'ppe-offices': () => import('./art/ppe-offices.generated'),
}

// What a planned pictogram — named and typed, its art not drawn yet — is drawn with.
export const PLACEHOLDER_NODES: IconNode = [
  [
    'path',
    {
      key: '0',
      d: 'M0 8C0 3.6 3.6 0 8 0H32C36.4 0 40 3.6 40 8V32C40 36.4 36.4 40 32 40H8C3.6 40 0 36.4 0 32V8Z',
      fill: '#EEF2F6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '1',
      d: 'M10 2.8C10 2.3 10.3 2 10.8 2H13.3C13.7 2 14 2.3 14 2.8V2.8C14 3.2 13.7 3.5 13.3 3.5H10.8C10.3 3.5 10 3.2 10 2.8V2.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '2',
      d: 'M10 37.3C10 36.8 10.3 36.5 10.8 36.5H13.3C13.7 36.5 14 36.8 14 37.3V37.3C14 37.7 13.7 38 13.3 38H10.8C10.3 38 10 37.7 10 37.3V37.3Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '3',
      d: 'M2 10.8C2 10.3 2.3 10 2.8 10H2.8C3.2 10 3.5 10.3 3.5 10.8V13.3C3.5 13.7 3.2 14 2.8 14H2.8C2.3 14 2 13.7 2 13.3V10.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '4',
      d: 'M36.5 10.8C36.5 10.3 36.8 10 37.3 10H37.3C37.7 10 38 10.3 38 10.8V13.3C38 13.7 37.7 14 37.3 14H37.3C36.8 14 36.5 13.7 36.5 13.3V10.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '5',
      d: 'M18 2.8C18 2.3 18.3 2 18.8 2H21.3C21.7 2 22 2.3 22 2.8V2.8C22 3.2 21.7 3.5 21.3 3.5H18.8C18.3 3.5 18 3.2 18 2.8V2.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '6',
      d: 'M18 37.3C18 36.8 18.3 36.5 18.8 36.5H21.3C21.7 36.5 22 36.8 22 37.3V37.3C22 37.7 21.7 38 21.3 38H18.8C18.3 38 18 37.7 18 37.3V37.3Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '7',
      d: 'M2 18.8C2 18.3 2.3 18 2.8 18H2.8C3.2 18 3.5 18.3 3.5 18.8V21.3C3.5 21.7 3.2 22 2.8 22H2.8C2.3 22 2 21.7 2 21.3V18.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '8',
      d: 'M36.5 18.8C36.5 18.3 36.8 18 37.3 18H37.3C37.7 18 38 18.3 38 18.8V21.3C38 21.7 37.7 22 37.3 22H37.3C36.8 22 36.5 21.7 36.5 21.3V18.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '9',
      d: 'M26 2.8C26 2.3 26.3 2 26.8 2H29.3C29.7 2 30 2.3 30 2.8V2.8C30 3.2 29.7 3.5 29.3 3.5H26.8C26.3 3.5 26 3.2 26 2.8V2.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '10',
      d: 'M26 37.3C26 36.8 26.3 36.5 26.8 36.5H29.3C29.7 36.5 30 36.8 30 37.3V37.3C30 37.7 29.7 38 29.3 38H26.8C26.3 38 26 37.7 26 37.3V37.3Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '11',
      d: 'M2 26.8C2 26.3 2.3 26 2.8 26H2.8C3.2 26 3.5 26.3 3.5 26.8V29.3C3.5 29.7 3.2 30 2.8 30H2.8C2.3 30 2 29.7 2 29.3V26.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '12',
      d: 'M36.5 26.8C36.5 26.3 36.8 26 37.3 26H37.3C37.7 26 38 26.3 38 26.8V29.3C38 29.7 37.7 30 37.3 30H37.3C36.8 30 36.5 29.7 36.5 29.3V26.8Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      key: '13',
      d: 'M20 7C23.9 7 27 10.1 27 14C27 17.9 23.9 21 20 21C16.1 21 13 17.9 13 14C13 10.1 16.1 7 20 7ZM20 10.5C21.9 10.5 23.5 12.1 23.5 14C23.5 15.9 21.9 17.5 20 17.5C18.1 17.5 16.5 15.9 16.5 14C16.5 12.1 18.1 10.5 20 10.5Z',
      fill: '#3B6FB6',
      stroke: 'none',
      fillRule: 'evenodd',
    },
  ],
  [
    'path',
    { key: '14', d: 'M12.5 14H20V21.5H12.5Z', fill: '#EEF2F6', stroke: 'none' },
  ],
  [
    'path',
    { key: '15', d: 'M18.3 19H21.8V25H18.3Z', fill: '#3B6FB6', stroke: 'none' },
  ],
  [
    'path',
    {
      key: '16',
      d: 'M20 27.4C21.2 27.4 22.1 28.3 22.1 29.5C22.1 30.7 21.2 31.6 20 31.6C18.8 31.6 17.9 30.7 17.9 29.5C17.9 28.3 18.8 27.4 20 27.4Z',
      fill: '#3B6FB6',
      stroke: 'none',
    },
  ],
]
